import { render, staticRenderFns } from "./StatsForm.vue?vue&type=template&id=74a8e868&scoped=true"
import script from "./StatsForm.vue?vue&type=script&lang=js"
export * from "./StatsForm.vue?vue&type=script&lang=js"
import style0 from "./StatsForm.vue?vue&type=style&index=0&id=74a8e868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a8e868",
  null
  
)

export default component.exports